module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "",
    attrs: {
      "id": ""
    }
  }, [_c('input', {
    ref: "idFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".apk,.zip"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('div', {
    ref: "idFName",
    staticStyle: {
      "float": "left",
      "width": "460px",
      "height": "40px",
      "line-height": "40px",
      "text-indent": "10px",
      "margin-top": "30px",
      "border-bottom": "2px solid #cccccc"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "width": "110px",
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "36px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onFileClick
    }
  }, [_vm._v("选择文件")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "12px",
      "margin-top": "3px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "580px",
      "height": "12px",
      "border-radius": "5px",
      "border": "1px solid #2a83cf",
      "margin-top": "16px",
      "display": "block",
      "position": "relative"
    }
  }, [_c('div', {
    ref: "idProgBar",
    staticStyle: {
      "position": "absolute",
      "width": "0%",
      "height": "10px",
      "line-height": "10px",
      "border-radius": "5px",
      "background": "#b4ea74"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idProgCapt",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "10px",
      "line-height": "10px",
      "color": "#2a83cf",
      "text-align": "center",
      "font-size": "8px",
      "font-style": "italic"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "30px",
      "margin-left": "10px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('radio', {
    ref: "idForce1",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'GrpForce',
      "val": '1',
      "capt": '强制'
    },
    model: {
      value: (_vm.force),
      callback: function($$v) {
        _vm.force = $$v
      },
      expression: "force"
    }
  }), _vm._v(" "), _c('radio', {
    ref: "idForce0",
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "root": {
        obj: this
      },
      "grpName": 'GrpForce',
      "val": '0',
      "capt": '不强制'
    },
    model: {
      value: (_vm.force),
      callback: function($$v) {
        _vm.force = $$v
      },
      expression: "force"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "40px",
      "margin-top": "20px",
      "border": "0px solid red"
    }
  }, [_c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-left": "50px"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-right": "50px",
      "float": "right"
    },
    on: {
      "click": _vm.onUploadClick
    }
  }, [_vm._v("上传")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1886b088","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/verNew.vue
// module id = 765
// module chunks = 1